<template>
  <div class="d-flex flex-column justify-center mx-auto my-n3" style="width: 200px;">

    <error-dialog :status="loadStripeCardElementStatus" />
    <error-dialog :status="submitPaymentStatus" />
    <error-dialog :status="fulfillNoPaymentStatus" />
    <error-dialog :status="submitOfflinePaymentStatus" />
    <error-dialog :status="loadNMIInputsStatus" />
    <error-dialog :status="submitNMIPaymentStatus" />

    <v-dialog v-if="promo" width="430" :value="!!promo" @input="promo = null">
      <v-card>
        <v-btn class="float-right ma-3" icon @click="promo = null">
          <v-icon v-html="mdiClose" />
        </v-btn>
        <template v-if="promo == 'INTERCEPT'">
          <div class="title px-6 pt-4">Do you want to subscribe to send <b>unlimited</b> cards and videos?</div>
          <div class="px-6 pt-4 pb-16">
            <v-btn color="primary" @click="promo = null; showCardDialog = true;">
              No, continue to payment…
            </v-btn>
          </div>
        </template>
        <div v-else class="title px-6 py-4">Subscribe to send <b>unlimited</b> cards and videos</div>
        <v-divider />
        <v-card-text class="pt-6 grey lighten-4 overflow-auto">
          <pricing-subscriptions hide-description @purchase="promo = null; $emit('purchase-subscription');" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog eager width="400" :persistent="submitPaymentStatus.pending" v-model="showCardDialog">
      <v-card>
        <v-btn
          class="ma-3" style="position: absolute; right: 0;"
          icon
          :disabled="submitPaymentStatus.pending"
          @click="showCardDialog = false"
        >
          <v-icon v-html="mdiClose" />
        </v-btn>
        <v-card-title class="d-flex justify-center py-6">
          <price class="text-h4" :value="itemized.price" />
        </v-card-title>
        <v-divider />
        <div class="px-4 pt-6 pb-4">
          <div style="position: relative;">
            <v-text-field
              dense outlined readonly label="Card" value=" "
              :error="!!cardError" :error-messages="cardError ? [ cardError ] : []"
              :loading="loadStripeCardElementStatus.pending"
            />
            <div ref="card-element" class="mx-3 mt-3" style="position: absolute; top: 0; left: 0; right: 0;" />
          </div>
          <div id="card-errors" role="alert" />
          <div class="mt-1 text-center">
            <img class="d-inline-block" width="120" src="../assets/credit-cards-448.png" />
          </div>
        </div>
        <v-divider />
        <v-card-actions>
          <v-checkbox class="ml-n1 mt-n1" hide-details label="Save card" :disabled="forceSaveCard" v-model="saveCard" />
          <v-spacer />
          <v-btn :disabled="submitPaymentStatus.pending" @click="showCardDialog = false">Cancel</v-btn>
          <v-btn
            color="primary"
            :disabled="!isCardComplete" :loading="submitPaymentStatus.pending"
            @click="submitPayment({ card })"
          >
            Pay now
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog width="400" :persistent="didSubmitNMIPayment || submitNMIPaymentStatus.pending" v-model="showNMI">
      <v-card>
        <v-btn
          class="ma-3" style="position: absolute; right: 0;"
          icon
          :disabled="didSubmitNMIPayment || submitNMIPaymentStatus.pending"
          @click="showNMI = false"
        >
          <v-icon v-html="mdiClose" />
        </v-btn>
        <v-card-title class="d-flex justify-center py-6">
          <price class="text-h4" :value="itemized.price" />
        </v-card-title>
        <v-divider />
        <div v-if="loadNMIInputsStatus.pending" class="relative">
          <v-progress-linear class="absolute fill-width" indeterminate />
        </div>
        <div class="px-4 pt-6 pb-4">
          <v-row>
            <v-col cols="12">
              <div class="relative" style="height: 40px; width: 100%;">
                <label for="nmi-cc-number" class="absolute white px-1 text--label-active" style="top: -8px; left: 9px; pointer-events: none;">Credit card number</label>
                <div id="nmi-cc-number"></div>
              </div>
            </v-col>
            <v-col cols="8">
              <div class="relative" style="height: 40px; width: 100%;">
                <label for="nmi-cc-number" class="absolute white px-1 text--label-active" style="top: -8px; left: 9px; pointer-events: none;">Expiration</label>
                <div id="nmi-cc-exp"></div>
              </div>
            </v-col>
            <v-col cols="4">
              <div class="relative" style="height: 40px; width: 100%;">
                <label for="nmi-cc-number" class="absolute white px-1 text--label-active" style="top: -8px; left: 9px; pointer-events: none;">CVV</label>
                <div id="nmi-cc-cvv"></div>
              </div>
            </v-col>
          </v-row>

          <div class="mt-8 text-center">
            <img class="d-inline-block" width="120" src="../assets/credit-cards-448.png" />
          </div>
        </div>
        <v-divider />
        <v-card-actions>
          <v-checkbox
            class="ml-n1 mt-n1"
            hide-details label="Save card"
            :disabled="forceSaveCard"
            v-model="saveCard"
          />
          <v-spacer />
          <v-btn :disabled="didSubmitNMIPayment || submitNMIPaymentStatus.pending" @click="showNMI = false">
            Cancel
          </v-btn>
          <v-btn
            id="nmi-pay-now"
            color="primary"
            :disabled="loadNMIInputsStatus.pending || didSubmitNMIPayment || submitNMIPaymentStatus.pending"
            :loading="loadNMIInputsStatus.pending || didSubmitNMIPayment || submitNMIPaymentStatus.pending"
            @click="didSubmitNMIPayment = isNMIValid"
          >
            Pay now
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- TODO: you had started working on this to take card details directly just in case, since you don't know how the new payment processor is going to work -->
    <!--
    <v-dialog eager width="400" v-model="showDirectCardDialog">
      <v-card>
        <v-btn class="ma-3" style="position: absolute; right: 0;" icon @click="showDirectCardDialog = false">
          <v-icon v-html="mdiClose" />
        </v-btn>
        <v-card-title class="d-flex justify-center py-6">
          <div class="grey--text text-h5 mr-4" style="line-height: 3.125rem;">$</div>
          <div class="d-flex align-top">
            <span class="display-2">{{itemized.price.split('.')[0]}}</span>
            <span class="text-body-1">{{itemized.price.split('.')[1]}}</span>
          </div>
        </v-card-title>
        <v-divider />
        <div class="px-4 pt-6 pb-4">
          <v-text-field
            dense outlined readonly label="Card" value=" "
            v-mask="'#### #### #### ####'" type="tel"
            Xerror="!!cardError" Xerror-messages="cardError ? [ cardError ] : []"
          />
          <div class="mt-1 text-center">
            <img class="d-inline-block" width="120" src="../assets/credit-cards-448.png" />
          </div>
        </div>
        <v-divider />
        <v-card-actions>
          <v-checkbox class="ml-n1 mt-n1" hide-details label="Save card" :disabled="forceSaveCard" v-model="saveCard" />
          <v-spacer />
          <v-btn @click="showDirectCardDialog = false">Cancel</v-btn>
          <v-btn color="primary" :disabled="true">
            Pay now
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    -->

    <v-progress-circular v-if="loadExternalPaymentRequestButtonStatus.pending" class="my-3 mx-auto" indeterminate />

    <v-btn
      v-else-if="itemized.price == '0.00'"
      class="my-3"
      color="primary"
      :loading="fulfillNoPaymentStatus.pending"
      @click="fulfillNoPayment"
    >
      Complete checkout
    </v-btn>

    <template v-else>
      <template v-if="supportedProcessors.STRIPE_CARD">
        <v-btn
          v-if="savedPaymentMethods.length == 1"
          class="my-3"
          width="200"
          :loading="submitOfflinePaymentStatus.pending"
          @click="submitOfflinePayment(savedPaymentMethod.id)"
        >
          <credit-card-preview :card="savedPaymentMethod.card" />
        </v-btn>
        <div v-else-if="savedPaymentMethods.length > 1" class="my-3 btn-group d-flex" style="width: 200px;">
          <v-btn
            class="btn-group-right flex-grow-1"
            :loading="submitOfflinePaymentStatus.pending"
            @click="submitOfflinePayment(savedPaymentMethod.id)"
          >
            <credit-card-preview :card="savedPaymentMethod.card" />
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="btn-group-left px-2" v-bind="attrs" v-on="on">
                <v-icon v-html="mdiMenuDown" />
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="item in savedPaymentMethods" :key="item.id" @click="submitOfflinePayment(item.id)">
                <credit-card-preview :card="item.card" />
                <div v-if="item.description" class="ml-2 text--label-active">{{item.description}}</div>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>

      <div v-if="supportedProcessors.STRIPE_CARD" class="my-3">
        <v-btn
          color="primary" width="200"
          @click="() => {
            if (shouldSeePromo)
              promo = 'INTERCEPT';
            else
              showCardDialog = true;
          }"
        >
          <v-icon class="mr-1" color="white" v-html="mdiCreditCard" />{{savedPaymentMethod ? 'New ' : ''}}Card
        </v-btn>
      </div>

      <div v-if="supportedProcessors.NMI_CARD" class="my-3">
        <v-btn color="primary" width="200" @click="showNMI = true">
          <v-icon class="mr-1" color="white" v-html="mdiCreditCard" />New card
        </v-btn>
      </div>

      <paypal
        v-if="supportedProcessors.PAYPAL"
        v-bind="$props"
        class="my-3"
        :progress.sync="paypalInProgress"
        @complete="onComplete"
        @price-update="$emit('price-update')"
      />

      <div
        v-if="supportedProcessors.STRIPE_EXTERNAL && canMakeExternalStripePayment"
        class="my-3 v-btn v-btn--is-elevated align-center overflow-hidden"
        style="height: 36px; max-height: 36px;"
      >
        <div ref="payment-request" style="width: 100%;" />
      </div>

      <div v-if="shouldSeePromo" class="my-3">
        <v-btn class="friendly-font font-weight-bold" style="text-transform: unset;" dark color="pink" width="200" @click="promo = 'DIRECT'">
          Subscribe and save
        </v-btn>
      </div>
    </template>

  </div>
</template>


<style scoped>
.btn-intercept {
  cursor: pointer;
  transition: background-color .2s;
  z-index: 1;
}
.btn-intercept:hover {
  background-color: rgb(255,255,255,.2);
}
</style>


<script>
import CreditCardPreview from '@/components/CreditCardPreview.vue';
import ErrorDialog from '@/components/ErrorDialog.vue';
import Paypal from '@/components/Paypal.vue';
import Price from '@/components/Price.vue';
import PricingSubscriptions from '@/components/PricingSubscriptions.vue';
import SignInDialog from '@/components/SignInDialog.vue';
import { LOCALE } from '@/utils/intl.js';
import loadScript from '@/utils/load-script.js';
import { recordPurchase } from '@/utils/purchase-metrics.js';
import { mdiAccount, mdiClose, mdiCreditCard, mdiMenuDown, mdiInformation, mdiCurrencyUsd } from '@mdi/js';


const USE_NMI = false;


export default {
  name: 'payment-btns',

  components: {
    CreditCardPreview,
    ErrorDialog,
    Paypal,
    Price,
    PricingSubscriptions,
    SignInDialog
  },

  props: [ 'itemized', 'metadata' ],

  // Events:
  // @price-update
  // @complete

  data() {
    return {
      savedPaymentMethod: null,
      savedPaymentMethods: [],
      card: null,
      isCardComplete: false,
      cardError: null,
      showCardDialog: false,
      showNMI: false,
      nmiStatus: { ccnumber: false, ccexp: false, cvv: false },
      didSubmitNMIPayment: false,
      // showDirectCardDialog: false,
      canMakeExternalStripePayment: null,
      showSignIn: false,
      saveCard: true,
      paypalInProgress: false,
      didClosePromo: false,
      promo: null,
      loadStripeCardElementStatus: this.$track('loadStripeCardElement'),
      loadSavedPaymentMethodsStatus: this.$track('loadSavedPaymentMethods'),
      loadExternalPaymentRequestButtonStatus: this.$track('loadExternalPaymentRequestButton'),
      submitPaymentStatus: this.$track('submitPayment'),
      fulfillNoPaymentStatus: this.$track('fulfillNoPayment'),
      submitOfflinePaymentStatus: this.$track('submitOfflinePayment'),
      loadNMIInputsStatus: this.$track('loadNMIInputs'),
      submitNMIPaymentStatus: this.$track('submitNMIPayment')
    };
  },

  computed: {
    supportedProcessors() {
      const allowed = { NMI_CARD: USE_NMI, STRIPE_CARD: !USE_NMI, PAYPAL: true, STRIPE_EXTERNAL: !USE_NMI };
      for (const item of this.itemized.items) {
        if (item.key == 'SUBSCRIPTION') {
          allowed.PAYPAL = false;
          allowed.STRIPE_EXTERNAL = false;
        } else if (item.key.startsWith('GIFTCARD')) {
          allowed.PAYPAL = false;
          allowed.STRIPE_EXTERNAL = false;
        }
      }
      return allowed;
    },

    forceSaveCard() {
      return !!this.itemized.items.find(x => x.key == 'SUBSCRIPTION');
    },

    shouldSeePromo() {
      if ((this.metadata?.target != 'CARD') || this.global.profile?.org_id)
        return false;
      const priceCents = parseInt(this.itemized.price.replace('.', ''));
      const giftCardSumCents = this.itemized.items.reduce(
        (sum, x) => sum + ([ 'GIFTCARD', 'GIFTCARD_FEE' ].includes(x.key) ? parseInt(x.unit.replace('.', '')) : 0),
        0
      );
      if (priceCents - giftCardSumCents <= 0)
        // This order must already have free credits / discounts applied (it would be super annoying to prompt again)
        return false;
      return true;
    },

    isNMIValid() {
      return Object.values(this.nmiStatus).every(x => x);
    }
  },

  created() {
    Object.assign(this, { mdiAccount, mdiClose, mdiCreditCard, mdiMenuDown, mdiInformation, mdiCurrencyUsd });
    window._stripeFrames = (window._stripeFrames || 0) + 1;
  },

  mounted() {
    this.loadStripeCardElement();
  },

  async beforeDestroy() {
    // Stripe leaves around lots of iframes that it shouldn't. There's not a good mechanism for removing these and
    // their listeners, but this seems to work.
    // https://github.com/stripe-archive/react-stripe-elements/issues/99
    // https://gist.github.com/brndnmtthws/c5b28592c321533b8aa6971212295045
    const stripe = await loadStripePromise;
    window._stripeFrames--;
    if (!window._stripeFrames) {
      // Note that we're careful not to remove any frames unless this is the only instance
      for (const frame of Object.values(stripe._controller._frames)) {
        frame._iframe.remove();
        frame._removeAllListeners();
      }
    }
  },

  methods: {
    async loadExternalPaymentRequestButton() {
      if (this.itemized.price == '0.00' || !this.supportedProcessors.STRIPE_EXTERNAL)
        return;

      // https://stripe.com/docs/stripe-js/elements/payment-request-button
      const stripe = await loadStripePromise;

      this.canMakeExternalStripePayment = null;
      this.externalPaymentRequest = stripe.paymentRequest({
        country: 'US',
        currency: 'usd',
        total: {
          label: 'Total',
          amount: parseInt(this.itemized.price.replace('.', ''))
        }
      });

      this.externalPaymentRequest.on('cancel', console.log);

      this.externalPaymentRequest.on(
        'paymentmethod',
        async e => {
          this.saveCard = false;
          try {
            await this.submitPayment(e.paymentMethod.id);
            e.complete('success');
          } catch (e) {
            e.complete('fail');
          }
        }
      );

      this.canMakeExternalStripePayment = await this.externalPaymentRequest.canMakePayment();
      await this.loadSavedPaymentMethodsStatus.promise;

      if (this.canMakeExternalStripePayment)
        setTimeout(() => stripe.elements().create('paymentRequestButton', { paymentRequest: this.externalPaymentRequest }).mount(this.$refs['payment-request']));
    },

    async loadStripeCardElement() {
      const stripe = await loadStripePromise;

      const computed = getComputedStyle(this.$el, null);
      const style = {
        base: {
          color: computed.getPropertyValue('color'),
          fontFamily: computed.getPropertyValue('font-family'),
          fontSize: computed.getPropertyValue('font-size')
        },
        invalid: {
          color: this.$vuetify.theme.defaults.light.error
        }
      };
      this.card = stripe.elements().create('card', { style });
      this.isCardComplete = false;
      this.cardError = null;
      this.card.on('change', e => {
        this.isCardComplete = e.complete;
        this.cardError = e.error ? e.error.message : null;
      });
      this.card.mount(this.$refs['card-element']);
    },

    async loadNMIInputs() {
      // https://secure.nmi.com/merchants/resources/integration/integration_portal.php
      this.nmiStatus = { ccnumber: false, ccexp: false, cvv: false };
      if (!window.CollectJS)
        await loadScript(
          'https://secure.nmi.com/token/Collect.js',
          { 'data-tokenization-key': '2qX6R2-8Hw8YH-7Un2uN-Sa9Jk4', 'data-variant': 'inline' }
        );
      await new Promise(
        fieldsAvailableCallback => CollectJS.configure({
          paymentSelector : '#nmi-pay-now',
          variant : 'inline',
          styleSniffer : false,
          googleFont: 'Nunito',
          customCss : {
            'color': 'rgba(0, 0, 0, 0.87)',
            'padding': '9px 12px',
            'line-height': '20px',
            'font-family': 'Nunito, Helvetica, sans-serif',
            'font-size': '16px',
            'border-radius': '4px',
            'border-color': 'rgba(0, 0, 0, 0.38) !important',
            'border-width': '1px',
            'border-style': 'solid'
          },
          invalidCss: {
            'border-color': 'rgba(255, 82, 82)'
          },
          fields: {
            ccnumber: {
              selector: '#nmi-cc-number',
              title: 'Card number',
              placeholder: "0000 0000 0000 0000"
            },
            ccexp: {
              selector: '#nmi-cc-exp',
              title: 'Expiration',
              placeholder: '00 / 00'
            },
            cvv: {
              selector: '#nmi-cc-cvv',
              title: 'CVV',
              placeholder: '***'
            }
          },
          price: this.itemized.price,
          currency:'USD',
          country: 'US',
          validationCallback: (field, status, msg) => this.nmiStatus[field] = status,
          fieldsAvailableCallback,
          timeoutDuration: 10000,
          timeoutCallback: () => this.submitNMIPayment(),
          callback: r => this.submitNMIPayment(r)
        })
      );
    },

    async checkSubmitPayment(params, offline) {
      // Errors are standardized across both of these APIs
      const api = offline ? 'stripe/complete-offline-payment' : 'stripe/create-payment-intent';

      // DEBUG
      $event.log('api-call', { api, data: params });

      let response;
      try {
        response = await this[ offline ? 'pay' : '$call' ](api, params);
        if (response.price_update) {
          this.$emit('price-update');
          return null;
        }
        if (response.card_error)
          throw new VisibleError(response.card_error);
      } catch (e) {
        if (e.type == 'LockedPaymentIntent')
          throw new VisibleError('Sorry, this account has been locked - please contact us: <a href="mailto:support@ellacard.com">support@ellacard.com</a>');
        if (e.type == 'MultipleFailedPaymentIntents')
          throw new VisibleError('Sorry, this account has been temporarily locked due to too many incomplete payment attempts - please contact us: <a href="mailto:support@ellacard.com">support@ellacard.com</a>');
        if (this.$listeners.error) {
          this.$emit('error', e);
          return null;
        }
        throw e;
      }
      return response;
    },

    async pay(api, params) {
      try {
        this.$emit('update:progress', true);
        return await this.$call(api, params);
      } finally {
        this.$emit('update:progress', false);
      }
    },

    async submitPayment(payment_method) {
      const params = { metadata: this.metadata, locale: LOCALE, items: this.itemized.items, save: this.saveCard };
      const response = await this.checkSubmitPayment(params, false);
      if (!response)
        return;
      const stripe = await loadStripePromise;
      const confirmed = await stripe.confirmCardPayment(response.client_secret, { payment_method });
      if (confirmed.error)
        throw new VisibleError(confirmed.error.message);
      if (confirmed.paymentIntent.status != 'succeeded')
        throw new Error('Unknown');

      // DEBUG
      $event.log('api-call', { api: 'stripe/complete-payment-intent', data: { payment_intent_id: confirmed.paymentIntent.id } });

      const id = await this.pay('stripe/complete-payment-intent', { payment_intent_id: confirmed.paymentIntent.id });
      this.showCardDialog = false;
      this.onComplete(id);
    },

    async submitOfflinePayment(payment_method_id) {
      if (USE_NMI)
        return await this.submitNMIOfflinePayment(payment_method_id);
      const params = { metadata: this.metadata, locale: LOCALE, items: this.itemized.items, payment_method_id };
      const response = await this.checkSubmitPayment(params, true);
      if (response)
        this.onComplete(response.payment_id);
    },

    async submitNMIPayment(tokenResponse) {
      this.didSubmitNMIPayment = false;
      if (!tokenResponse)
        throw new Error('No response');
      const params = {
        token: tokenResponse.token,
        metadata: this.metadata,
        locale: LOCALE,
        items: this.itemized.items,
        save: this.saveCard
      };
      // TODO: capture errors
      const response = await this.pay('nmi/complete-payment', params);
      if (response.price_update)
        return this.$emit('price-update');
      this.showNMI = false;
      this.onComplete(response.payment_id);
    },

    async submitNMIOfflinePayment(customer_vault_id) {
      this.didSubmitNMIPayment = false;
      const params = {
        customer_vault_id,
        metadata: this.metadata,
        locale: LOCALE,
        items: this.itemized.items
      };
      // TODO: capture errors
      const response = await this.pay('nmi/complete-payment', params);
      if (response.price_update)
        return this.$emit('price-update');
      this.showNMI = false;
      this.onComplete(response.payment_id);
    },

    async fulfillNoPayment() {
      const params = { metadata: this.metadata, locale: LOCALE, items: this.itemized.items };
      const response = await this.$call('fulfill-no-payment', params);
      if (response.price_update)
        return this.$emit('price-update');
      this.$emit('complete', response);
    },

    async loadSavedPaymentMethods() {
      this.savedPaymentMethods = [];
      this.savedPaymentMethod = null;
      try {
        const route = USE_NMI ? 'nmi/list-payment-methods' : 'stripe/list-payment-methods';
        const r = await this.$call(route);
        this.savedPaymentMethods = r.payment_methods;
        this.savedPaymentMethod = r.payment_methods.find(x => x.id == r.primary);
      } catch (e) {
        // Should not block anything
      }
    },

    onComplete(id) {
      this.promo = null;
      const exclude = [ 'GIFTCARD', 'GIFTCARD_BATCH', 'CREDIT_GIFTCARD' ];
      let realizedI = parseInt(this.itemized.price.replace('.', ''));
      for (const item of this.itemized.items)
        if (exclude.includes(item.key))
          realizedI -= item.qty * parseInt(item.unit.replace('.', ''));
      const realized = Math.max(0, (realizedI / 100).toFixed(2));
      if (id)
        // This event can get triggered without an ID for payments that fail the idempotency check
        recordPurchase(id, realized);
      this.$emit('complete', id);
    }
  },

  watch: {
    globalUserId: {
      immediate: true,
      handler() {
        this.loadSavedPaymentMethods();
      }
    },

    itemized: {
      immediate: true,
      handler() {
        this.loadExternalPaymentRequestButton();
      }
    },

    forceSaveCard: {
      immediate: true,
      handler(v) {
        if (v)
          this.saveCard = true;
      }
    },

    'submitPaymentStatus.pending'(v) {
      this.card && this.card.update({ disabled: v });
    },

    'loadExternalPaymentRequestButtonStatus.pending': {
      immediate: true,
      handler(v) {
        this.$emit('update:loading', v);
      }
    },

    paypalInProgress(v) {
      this.promo = null;
      this.$emit('update:progress', v);
    },

    promo: {
      immediate: true,
      async handler(cur, prev) {
        this.$emit('update:is-promo-intercept-visible', !!cur);
        if (prev)
          this.didClosePromo = true;
      }
    },

    showNMI(v) {
      if (v)
        this.loadNMIInputs();
    }
  }
}
</script>
